
const Role = [
    {"role": {"name": "MEMBER","roleid": 1}},
    {"role": {"name": "ADMIN","roleid": 2}},
    {"role": {"name": "EXECUTIVE","roleid": 3}}
]

export default Role 